import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateVideosaggio } from '../../hooks/videosaggi'
import VideosaggioForm from '../../components/VideosaggioForm'

export default function VideosaggioCreate() {
  const createVideosaggio = useCreateVideosaggio()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/videosaggi">Videosaggi</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <VideosaggioForm
          save={async (video) => {
            const savedVideosaggio = await createVideosaggio.mutateAsync(video)
            navigate(`/videosaggi/${savedVideosaggio.id}`)
          }}
        />
      </div>
    </Page>
  )
}
